<template>
  <v-main>
    <header-bar v-model="drawer"></header-bar>
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </v-main>
</template>

<script>
const Header = () => import("../components/Layouts/Header");
export default {
  components: {
    "header-bar": Header,
  },
  data() {
    return {
      drawer: true,
      showAds: true,
      selectedItem: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: 0.25s;
}

.fade-enter-active {
  transition-delay: 0.25s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
